import { find, findAll } from "../utils/dom";
import Swiper from "swiper";

const PageAconteceuSingle = () =>{
	const page = find(`[js-page='aconteceu-single']`);
	if(!page) return;

	const SwiperAconteceu = new Swiper(".swiper-veja-tambem", {
		slidesPerView: 1.2,
		spaceBetween: 20,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},

		breakpoints:{
			767:{
				slidesPerView: 3.2,
				spaceBetween: 32,
				pagination:{
					dynamicBullets: false,
				}
			}
		}

	})

	const SwiperTopicos = new Swiper(".swiper-topicos", {
		slidesPerView: 'auto',
		spaceBetween: 8,
	})


	function constructListaTopicos(listaTopicos){
		const containerListaTopicos = find("[js-lista-topicos]");
		containerListaTopicos.innerHTML = '';
		listaTopicos?.forEach((item, index)=>{
			containerListaTopicos.innerHTML += `
				<li class="p-[.5rem] xl2:p-[.2rem_.2rem_.2rem_.5rem] group border-l-[2px] border-[transparent] hover:border-complementary-dark border-solid">
					<a href="#topico-${index}" class="text-headline-8 xl2:text-[1rem] text-neutral-100/40 transition-[color] duration-[.3s] linear group-hover:text-complementary-dark">
						${item}
					</a>
				</li>
			`
		});
	}

	function constructListaTopicosMobile(listaTopicos){
		const containerListaTopicosMobile = find("[js-lista-topicos-mobile]");
		containerListaTopicosMobile.innerHTML = '';
		listaTopicos?.forEach((item, index)=>{
			containerListaTopicosMobile.innerHTML += `
				<div class="swiper-slide w-fit">
					<a href="#topico-${index}" class="${(index == 0) ?'active':''} nav-mobile-topicos flex text-neutral-100/40 font-extrabold text-[1rem] py-[.5rem] ">
						${item}
					</a>
				</div>
			`
		})
	}

	function resetNavMobileTopicos(){
		const itens = findAll(".nav-mobile-topicos");
		if(!itens) return;

		itens.forEach((item)=>{
			item.classList.remove("active");
		})
	}

	function handleNavMobile(){
		const itens = findAll(".nav-mobile-topicos");
		if(!itens) return;

		itens.forEach((item)=>{
			item.addEventListener("click", (e)=>{
				resetNavMobileTopicos();
				e.target.classList.add("active");
			})
		})
	}


	const topicoList = find("[js-load-topicos]");

	const observer = new MutationObserver((mutacoes)=>{
		const topicos = mutacoes[0].target.querySelectorAll("h2");
		if(!topicos) return; 

		const listaTopicos = [];
		topicos?.forEach((topico, index) => {
			topico.setAttribute('id', `topico-${index}`);
			topico.classList.add("scroll-margin-top-1");
			listaTopicos.push(topico.innerText);
		});

		constructListaTopicos(listaTopicos);
		constructListaTopicosMobile(listaTopicos);
		handleNavMobile();

	});

	observer.observe(topicoList,{
		childList: true,
		characterData: true
	})

}

export default PageAconteceuSingle;